import ApiHook from './axiosAPI'

const { apiPOST, apiGET } = ApiHook()

const AuthAPI = {
  getDateTimer: async () => {
    const url = `auth/clock/?t=${new Date().getTime()}`
    const req = await apiGET(url, false)
    return req
  },
  validarRefreshToken: async idusuario => {
    const url = `/token/isValidRefreshTokenDinamico`
    const data = { idusuario }
    const req = await apiPOST(url, data, false, false)
    return req
  },
  enviarCodigoAutenticacao: async email => {
    const url = `/public/verificar_email_autenticacao/`
    const data = { email }
    return await apiPOST(url, data, true)
  },
  verificarCodigoAutenticacao: async (email, code) => {
    const url = `/public/verificar_codigo_autenticacao/`
    const data = { email, code }
    const reqs = await apiPOST(url, data, true)
    //console.log('reqs', reqs)
    return reqs
  },
  verificaDisponibilidadeEmail: async email => {
    const url = `/public/verificarDisponibilidadeLogin/?usuario=${email}`
    return await apiGET(url, true)
  },
  login: async (email, senha) => {
    const url = `/public/autenticarUsuario/`
    const data = {
      loginPorAPI: false,
      user: email,
      senha,
    }
    const req = await apiPOST(url, data, true)
    return req
  },
  loginComProvider: async data => {
    const url = `/public/login_com_provider/`
    const req = await apiPOST(url, data, true)
    return req
  },
  logout: async token => {
    const url = `/auth/logout/`
    const req = await apiPOST(url, { token })
    return req
  },
  cadastrar: async data => {
    const url = `/public/criar_usuario_com_email/`
    const req = await apiPOST(url, data, true)
    return req
  },
  buscarCidadesAtivas: async () => {
    const url = `/public/buscarCidadesAtivas`
    const req = await apiGET(url, true)
    return req
  },
}

export default AuthAPI
